var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53033 9.96967C7.23744 9.67678 6.76256 9.67678 6.46967 9.96967C6.17678 10.2626 6.17678 10.7374 6.46967 11.0303L7.53033 9.96967ZM12 15.5L11.4697 16.0303C11.7626 16.3232 12.2374 16.3232 12.5303 16.0303L12 15.5ZM17.5303 11.0303C17.8232 10.7374 17.8232 10.2626 17.5303 9.96967C17.2374 9.67678 16.7626 9.67678 16.4697 9.96967L17.5303 11.0303ZM6.46967 11.0303L11.4697 16.0303L12.5303 14.9697L7.53033 9.96967L6.46967 11.0303ZM12.5303 16.0303L17.5303 11.0303L16.4697 9.96967L11.4697 14.9697L12.5303 16.0303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.c7707ed1ead1402dfe775f5d11b498e2.svg";
export { ForwardRef as ReactComponent };